import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {Formik, Form, Field, ErrorMessage, FieldArray} from 'formik'
import {EditFoodMenuValidation} from '../Validations/AddFoodMenuValidation'
import {KTIcon} from '../../Ihouse/helpers'
import axios from '../../Helpers/Api_instance'
import {useNavigate, useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import FoodItemsModal from '../Modals/ShowFoodItemsModal'

const EditFoodForm = () => {
  const [initialValues, setinitialValues] = useState<any>({
    title: '',
    description: '',
    categoryId: '',
    status: '',
    type: '',
    image: null,
    isCombo: 'No',
    comboCategories: [{categoryId: '', items: []}],
  })

  const [notComboCats, setNotComboCats] = useState<any>([])
  const [categories, setCategories] = useState([])
  const [showFoodModal, setShowFoodModal] = useState(false)
  const [categoryItems, setCategoryItems] = useState([])
  const [categoryId, setCategoryId] = useState<null | number>(null)
  const navigate = useNavigate()
  const {id} = useParams()
  const onSubmit = async (values, {setSubmitting}) => {
    console.log(values)
    try {
      const formData = new FormData()
      formData.append('title', values.title)
      formData.append('description', values.description)
      formData.append('categoryId', values.categoryId)
      formData.append('type', values.type)
      formData.append('status', values.status)
      if (values.image) {
        formData.append('image', values.image)
      }
      if (values.isCombo === 'Yes') {
        formData.append('isCombo', values.isCombo)
        formData.append('comboCategories', JSON.stringify(values.comboCategories))
      }
      const res = await axios.put('/foodmenu/' + id, formData)
      if (res && res.data) {
        toast.success('Food Item updated successfully')
        navigate('/foodmenu')
      }
    } catch (error: any) {
      console.error('Error submitting form:', error.message)
      toast.error('Unable update food item')
    } finally {
      setSubmitting(false)
    }
  }

  const getCategoriesWithoutCombos = async () => {
    try {
      const res = await axios.get('/category/not-combo')
      if (res && res.data) {
        setNotComboCats(res.data.data)
      }
    } catch (error: any) {
      console.log(error.message)
    }
  }

  const getCategoryFoodMenu = async () => {
    try {
      const res = await axios.get(`/foodmenu/category/${categoryId}`)
      if (res && res.data) {
        console.log('category data', res.data.data)
        setCategoryItems(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getFoodItemById = async () => {
    try {
      const res = await axios.get(`/foodmenu/${id}`)
      if (res && res.data) {
        console.log('res data', res.data)

        setinitialValues({
          ...res.data.data,
          isCombo: res.data.data.isCombo ? 'Yes' : 'No',
          comboCategories:
            res.data.data.comboCategories.length > 0
              ? res.data.data.comboCategories
              : [{categoryId: '', items: []}],
        })
        // setCategoryId(res.data.data.categoryId)
      }
    } catch (error: any) {
      console.log(error.message)
    }
  }

  const getCategories = async () => {
    try {
      const res = await axios.get('/category/all')
      if (res && res.data) {
        console.log('categoriues response', res.data.data)
        setCategories(res.data.data)
      }
    } catch (error: any) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getCategories()
    getCategoriesWithoutCombos()
  }, [])

  useEffect(() => {
    getFoodItemById()
  }, [id])
  useEffect(() => {
    if (categoryId) {
      getCategoryFoodMenu()
    }
  }, [categoryId])

  return (
    <div>
      <div className='col-sm-12 col-xl-12 col-md-12'>
        <div className='card card-custom'>
          <div className='card-header'>
            <div className='card-title m-0'>
              <h2>Update Food Item</h2>
            </div>
            <div className='card-toolbar'>
              <Link
                to={'/foodmenu'}
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3'
              >
                <KTIcon iconName='exit-left' className='fs-1' />
              </Link>
            </div>
          </div>
          <div className='card-body'>
            <Formik
              initialValues={initialValues}
              validationSchema={EditFoodMenuValidation}
              onSubmit={onSubmit}
              enableReinitialize
            >
              {({setFieldValue, values}) => (
                <Form>
                  <div className='row mb-4'>
                    <div className='col-md-6 mb-3'>
                      <label className='form-label'>Title</label>
                      <Field
                        type='text'
                        name='title'
                        className='form-control'
                        placeholder='Enter title'
                      />
                      <ErrorMessage name='title' component='div' className='text-danger mt-1' />
                    </div>
                    <div className='col-md-6 mb-3'>
                      <label className='form-label'>Category</label>
                      <Field as='select' name='categoryId' className='form-select'>
                        <option value=''>Select Category</option>
                        {categories?.map((cat: any) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name='categoryId'
                        component='div'
                        className='text-danger mt-1'
                      />
                    </div>
                  </div>

                  <div className='row mb-4'>
                    <div className='col-md-4 mb-3'>
                      <label className='form-label'>Status</label>
                      <Field as='select' name='status' className='form-select'>
                        <option value=''>Select Status</option>
                        <option value='Active'>Active</option>
                        <option value='Inactive'>Inactive</option>
                      </Field>
                      <ErrorMessage name='status' component='div' className='text-danger mt-1' />
                    </div>
                    <div className='col-md-4 mb-3'>
                      <label className='form-label'>Type</label>
                      <Field as='select' name='type' className='form-select'>
                        <option value=''>Select Type</option>
                        <option value='Veg'>Veg</option>
                        <option value='Non-Veg'>Non-Veg</option>
                      </Field>
                      <ErrorMessage name='type' component='div' className='text-danger mt-1' />
                    </div>
                    <div className='col-md-4 mb-3'>
                      <label className='form-label'>Combo</label>
                      <Field as='select' name='isCombo' className='form-select'>
                        <option value=''>Select </option>
                        <option value='Yes'>Yes</option>
                        <option value='No'>No</option>
                      </Field>
                      <ErrorMessage name='type' component='div' className='text-danger mt-1' />
                    </div>
                  </div>
                  <div className='mb-4'>
                    <label className='form-label'>Description</label>
                    <Field as='textarea' name='description' className='form-control' rows={3} />
                    <ErrorMessage name='description' component='div' className='text-danger mt-1' />
                  </div>
                  <div className='row'>
                    <div className='mb-4 col'>
                      <label className='form-label'>Image</label>
                      <input
                        type='file'
                        className='form-control'
                        onChange={(e: any) => setFieldValue('image', e.target.files[0])}
                      />
                    </div>
                  </div>

                  {values?.isCombo === 'Yes' && (
                    <FieldArray name='comboCategories'>
                      {({push, remove, form}) => (
                        <div className='mb-4'>
                          <div className='d-flex justify-content-between align-items-center mb-3'>
                            <h5 className='mb-0'>Combo Categories</h5>
                            <button
                              type='button'
                              className='btn btn-sm btn-light-success'
                              onClick={() =>
                                push({
                                  categoryId: '',
                                  items: [],
                                })
                              }
                            >
                              Add Combo Category
                            </button>
                          </div>

                          {form?.values?.comboCategories?.map((combo, index) => (
                            <div key={index} className='border rounded p-3 mb-3'>
                              <div className='d-flex justify-content-between align-items-center mb-3'>
                                <h6 className='mb-0'>Combo Category {index + 1}</h6>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-light-danger'
                                  onClick={() => remove(index)}
                                >
                                  Remove
                                </button>
                              </div>

                              <div className='row'>
                                <div className='col-md-6 mb-3'>
                                  <label className='form-label'>Category</label>
                                  <Field
                                    as='select'
                                    name={`comboCategories[${index}].categoryId`}
                                    className='form-select'
                                  >
                                    <option value=''>Select Category</option>
                                    {notComboCats?.map((cat: any) => (
                                      <option key={cat.id} value={cat.id}>
                                        {cat.name}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage
                                    name={`comboCategories[${index}].categoryId`}
                                    component='div'
                                    className='text-danger mt-1'
                                  />
                                </div>
                                <div className='col-md-6 mb-3'>
                                  <label className='form-label'>Food Items</label>
                                  <button
                                    className='btn btn-light-primary w-100'
                                    type='button'
                                    onClick={() => {
                                      setShowFoodModal(true)
                                      setCategoryId(combo.categoryId)
                                    }}
                                  >
                                    {values?.comboCategories[index]?.items?.length > 0
                                      ? `Selected ${values?.comboCategories[index]?.items?.length} Items`
                                      : 'Select Food Items'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                  )}
                  <div className='text-end'>
                    <Link to='/foodmenu' className='btn btn-light-danger me-2'>
                      Cancel
                    </Link>
                    <button type='submit' className='btn btn-primary'>
                      Submit
                    </button>
                  </div>
                  <FoodItemsModal
                    show={showFoodModal}
                    onHide={() => setShowFoodModal(false)}
                    foodItems={categoryItems}
                    selectedItems={
                      values?.comboCategories?.find((item: any) => item.categoryId === categoryId)
                        ?.items
                    }
                    onSelectItem={(id: any) => {
                      console.log('selected id', id)
                      const selectedCategory = values.comboCategories.find(
                        (item: any) => item.categoryId === categoryId
                      )
                      if (selectedCategory) {
                        const updatedItems = selectedCategory.items.includes(id)
                          ? selectedCategory.items.filter((item: any) => item !== id)
                          : [...selectedCategory.items, id]
                        setFieldValue(
                          `comboCategories[${values.comboCategories.indexOf(
                            selectedCategory
                          )}].items`,
                          updatedItems
                        )
                      }
                    }}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditFoodForm
